// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"404f8a7b50b755a12b7e","551":"b4afb710eee5880d59e6"}[chunkId] + ".css";
};